module.exports = __webpack_public_path__ + "images/forza-horizon-4_rgba(0,0,0,0.7).3990a17e7a71463520ed8639ce59a063.jpg";